import React, { useState } from 'react';
import mixpanel from 'mixpanel-browser';
import { FormControl } from '@mui/material';

import { ModalButtonRow } from '../ModalButtonRow';

import {
  TEXT,
  FULL_WIDTH,
  DOUBLE_FIELDS_WRAPPER,
  SINGLE_FIELD_WRAPPER,
} from '../../../constants/Dashboard';

import { RESIDENCY_MODAL, LIVE_DURATION } from '../../../constants/Dashboard/Residency';

import { getFieldType } from '../../../utils';

import './ResidencyModalContent.css';

export const ResidencyModalContent = ({ handleClose, onConfirm, residencyInfo, user }) => {
  const [residencyModalInfoState, setResidencyModalInfoState] = useState(residencyInfo);

  return (
    <>
      {RESIDENCY_MODAL.rows.map((row) => (
        <div
          key={row.map((column) => column.label).join('')}
          className="employment-modal-row-content"
        >
          {row.map((column) => {
            const element = getFieldType({
              type: column.fieldType,
              options: column?.options || [],
              value:
                column.label === LIVE_DURATION
                  ? residencyModalInfoState[column.label][column.placeholder]
                  : residencyModalInfoState[column.label],
              fieldEnumType: column.type || TEXT,
              textContent: column.text,
              helperText: column.helperText || '',
              onChange: (e) => {
                setResidencyModalInfoState((prevState) => {
                  let updatedState = prevState;

                  if (column.label === LIVE_DURATION) {
                    updatedState = {
                      ...prevState,
                      [column.label]: {
                        ...prevState[column.label],
                        [column.placeholder]: e.target.value,
                      },
                    };
                  } else {
                    updatedState = {
                      ...prevState,
                      [column.label]: e.target.value,
                    };
                  }

                  mixpanel.track('Residency Modal', {
                    user_id: user.id,
                    distinct_id: user.id,
                    residency_modal_state: updatedState,
                    field: column.label,
                  });

                  return updatedState;
                });
              },
            });

            const fullWidthOnMobile = column.fullWidthOnMobile ? FULL_WIDTH : '';
            const fieldWrappClass = row.length > 1 ? DOUBLE_FIELDS_WRAPPER : SINGLE_FIELD_WRAPPER;
            return (
              // clx css eventually
              <div
                key={column.label + ' ' + column.placeholder}
                className={fieldWrappClass + ' ' + fullWidthOnMobile}
              >
                {column.label && (
                  <p className="employment-field-label" style={{ ...column?.style }}>
                    {column.label}
                  </p>
                )}
                <FormControl sx={{ width: `100%`, pl: 0.5 }}>{element}</FormControl>
              </div>
            );
          })}
        </div>
      ))}
      <ModalButtonRow
        onCancel={handleClose}
        onConfirm={() => onConfirm({ residencyInfo: residencyModalInfoState })}
      />
    </>
  );
};
